<template>
<v-menu
  v-model="basketMenu"
  :close-on-content-click="false"
  offset-y
  max-width="420"
>
  <template v-slot:activator="{ on, attrs }">
    <v-btn
      icon
      class="ml-3"
      v-bind="attrs"
      v-on="on"
      :aria-label="$t('selection_basket_count', { count: selectedNodes.length })"
      :title="$t('selection_basket_count', { count: selectedNodes.length })"
    >
      <v-badge :content="String(selectedNodes.length)" color="primary" overlap>
        <v-icon>mdi-basket-outline</v-icon>
      </v-badge>
    </v-btn>
  </template>
  <v-card>
    <v-card-title class="subtitle-1">
      {{ $t('selection_basket_count', { count: selectedNodes.length }) }}
    </v-card-title>
    <v-card-text v-if="!selectedNodes.length">
      {{ $t('selection_basket_empty') }}
    </v-card-text>
    <v-list v-else dense class="selection-basket-list">
      <v-list-item v-for="node in selectedNodes" :key="node.node_id">
        <v-list-item-action class="mr-3">
          <v-checkbox
            v-model="basketRemovalIds"
            :value="node.node_id"
            :aria-label="$t('selection_basket_mark_remove', { name: node.name })"
            hide-details
          />
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title :title="node.name">{{ node.name }}</v-list-item-title>
          <v-list-item-subtitle :title="node.entry_fs_id">
            {{ node.entry_fs_id }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn
            icon
            :aria-label="$t('selection_basket_remove', { name: node.name })"
            @click="$emit('remove', [node.node_id])"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-card-actions v-if="selectedNodes.length">
      <v-spacer />
      <v-btn
        small
        text
        color="primary"
        :disabled="!basketRemovalIds.length"
        @click="$emit('remove', basketRemovalIds)"
      >{{ $t('selection_basket_remove_marked') }}</v-btn>
    </v-card-actions>
  </v-card>
</v-menu>
</template>

<script>
export default {
  name: 'SelectionBasket',
  props: {
    selectedNodes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return { basketMenu: false, basketRemovalIds: [] }
  },
  watch: {
    selectedNodes(nodes) {
      const ids = new Set(nodes.map(node => String(node.node_id)))
      this.basketRemovalIds = this.basketRemovalIds.filter(id => ids.has(String(id)))
    },
  },
}
</script>

<style scoped>
.selection-basket-list {
  max-height: 300px;
  overflow-y: auto;
}
</style>
